import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useRealtimeSocket from '../../hooks/useRealtimeSocket';
import { resetRealtime } from '../../store/realtimeSlice';
import { resetNotifications } from '../../store/notificationsSlice';
import { resetPresence } from '../../store/presenceSlice';
import { resetTimesheetTimer } from '../../store/timesheetTimerSlice';
import { useQueryClient } from '@tanstack/react-query';
import { clearModuleCaches } from '../../utils/clearModuleCaches';

const RealtimeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const location = useLocation();
  const user = useSelector((state) => state.core.user);
  const businessData = useSelector((state) => state.core.businessData);
  const businessId = businessData?.id;

  const { setPath } = useRealtimeSocket(businessId);

  useEffect(() => {
    if (user && businessId) {
      setPath(location.pathname);
    }
  }, [location.pathname, user, businessId, setPath]);

  useEffect(() => {
    if (!user) {
      dispatch(resetRealtime());
      dispatch(resetNotifications());
      dispatch(resetPresence());
      dispatch(resetTimesheetTimer());
      queryClient.clear();
      clearModuleCaches();
    }
  }, [user, dispatch, queryClient]);

  return <>{children}</>;
};

export default RealtimeProvider;
